// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__80cFu","tabs":"styles_tabs___QHBN","tab":"styles_tab__VAdEd","active":"styles_active____gD9"};